import { createApp } from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';
import router from './router'; // Importa el router
import axios from "@/plugins/axios"; // Asegúrate de que este archivo exista y esté configurado correctamente

loadFonts();

const app = createApp(App); // Declara la variable app

app.use(vuetify);
app.use(router); // Agrega Vue Router

// Configuración de Axios globalmente (opcional)
app.config.globalProperties.$axios = axios;

app.mount('#app'); //